"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ChangeTenantUserStatusRequestSchema () {
        return ChangeTenantUserStatusRequestSchema;
    },
    get InviteTenantUserRequestSchema () {
        return InviteTenantUserRequestSchema;
    },
    get InviteTenantUserResponseSchema () {
        return InviteTenantUserResponseSchema;
    },
    get ReplaceTenantUserRolesRequestSchema () {
        return ReplaceTenantUserRolesRequestSchema;
    },
    get TENANT_USER_DISPLAY_NAME_MAX_LENGTH () {
        return TENANT_USER_DISPLAY_NAME_MAX_LENGTH;
    },
    get TENANT_USER_EMAIL_MAX_LENGTH () {
        return TENANT_USER_EMAIL_MAX_LENGTH;
    },
    get TENANT_USER_ERROR_CODES () {
        return TENANT_USER_ERROR_CODES;
    },
    get TENANT_USER_MAX_ROLES () {
        return TENANT_USER_MAX_ROLES;
    },
    get TENANT_USER_STATUSES () {
        return TENANT_USER_STATUSES;
    },
    get TenantRoleListResponseSchema () {
        return TenantRoleListResponseSchema;
    },
    get TenantRoleSchema () {
        return TenantRoleSchema;
    },
    get TenantUserListResponseSchema () {
        return TenantUserListResponseSchema;
    },
    get TenantUserResponseSchema () {
        return TenantUserResponseSchema;
    },
    get TenantUserRoleSchema () {
        return TenantUserRoleSchema;
    },
    get TenantUserSchema () {
        return TenantUserSchema;
    }
});
const _zod = require("zod");
const TENANT_USER_STATUSES = [
    'active',
    'suspended',
    'invited'
];
const TENANT_USER_MAX_ROLES = 20;
const TENANT_USER_EMAIL_MAX_LENGTH = 254;
const TENANT_USER_DISPLAY_NAME_MAX_LENGTH = 200;
const TENANT_USER_ERROR_CODES = {
    /** `409`: a user in this tenant already has the email. */ emailTaken: 'USER_EMAIL_TAKEN',
    /** `400`: a role id isn't a role of this tenant or a system role. */ unknownRole: 'UNKNOWN_ROLE',
    /**
   * `403`: the role can't be given here, or not by this caller (ADR-0023 §10),
   * or it is a tenant role whose rules break the limits.
   */ roleNotAssignable: 'ROLE_NOT_ASSIGNABLE',
    /** `409`: the change would leave the tenant with no active admin with MFA. */ lastAdmin: 'LAST_ADMIN',
    /** `409`: only an invited user can get the invite again. */ notInvited: 'USER_NOT_INVITED',
    /** `409`: an invited user becomes active by accepting the invite, not by a status change. */ invitePending: 'USER_INVITE_PENDING',
    /**
   * `403` on `PUT /v1/rbac/roles/:id/permissions`: a tenant role may not
   * carry this rule (`manage all`, a platform-only subject, or a PHI write).
   */ permissionNotAllowed: 'PERMISSION_NOT_ALLOWED',
    /** `409` on PATCH users/:userId: a user can't suspend themselves. */ cannotSuspendSelf: 'CANNOT_SUSPEND_SELF'
};
const TenantUserRoleSchema = _zod.z.object({
    id: _zod.z.uuid(),
    name: _zod.z.string(),
    /** True for the seeded roles, false for the tenant's own roles. */ isSystem: _zod.z.boolean()
}).strict();
const TenantUserSchema = _zod.z.object({
    id: _zod.z.uuid(),
    email: _zod.z.string(),
    displayName: _zod.z.string().nullable(),
    status: _zod.z.enum(TENANT_USER_STATUSES),
    roles: _zod.z.array(TenantUserRoleSchema),
    /** TOTP or a passkey is set up. Never which one, never the factor itself. */ mfaEnrolled: _zod.z.boolean(),
    lastLoginAt: _zod.z.iso.datetime().nullable(),
    createdAt: _zod.z.iso.datetime()
}).strict();
const TenantUserListResponseSchema = _zod.z.object({
    items: _zod.z.array(TenantUserSchema)
}).strict();
const TenantUserResponseSchema = _zod.z.object({
    user: TenantUserSchema
}).strict();
const RoleIdsSchema = _zod.z.array(_zod.z.uuid()).max(TENANT_USER_MAX_ROLES);
const InviteTenantUserRequestSchema = _zod.z.object({
    email: _zod.z.string().trim().max(TENANT_USER_EMAIL_MAX_LENGTH).pipe(_zod.z.email()),
    displayName: _zod.z.string().trim().min(1).max(TENANT_USER_DISPLAY_NAME_MAX_LENGTH).optional(),
    roleIds: RoleIdsSchema.min(1)
}).strict();
const InviteTenantUserResponseSchema = _zod.z.object({
    user: TenantUserSchema,
    inviteEmailQueued: _zod.z.boolean()
}).strict();
const ReplaceTenantUserRolesRequestSchema = _zod.z.object({
    roleIds: RoleIdsSchema
}).strict();
const ChangeTenantUserStatusRequestSchema = _zod.z.object({
    status: _zod.z.enum([
        'active',
        'suspended'
    ])
}).strict();
const TenantRoleSchema = _zod.z.object({
    id: _zod.z.uuid(),
    name: _zod.z.string(),
    description: _zod.z.string().nullable(),
    isSystem: _zod.z.boolean()
}).strict();
const TenantRoleListResponseSchema = _zod.z.object({
    items: _zod.z.array(TenantRoleSchema)
}).strict();
